export default __webpack_public_path__ + "static/media/optiondot.4a871159.svg";